import { hasValidProperty } from "src/app/helpers/obj"

const hasFilterProps = (obj) => {
    const props = [
        'po_number',
        'from_date',
        'to_date',
        'customer_name',
        'sales_org_code',
        'regarding',
        'sector_id',
        'total_request_quantum',
        'total_request_price',
        'status',
    ]

    return hasValidProperty(obj, props)
}

export {
    hasFilterProps
}
